module.exports = __webpack_public_path__ + "static/img/top-bg.4c8e44cb.png";